import React, { useState, useEffect } from 'react';
import html2canvas from 'html2canvas'; // 추가
import { Header, Button, Pie, ChartsHeader } from '../components';
import {
  AgentName, dropdownDataFontSize, dropdownDataReviewPeriodStart, dropdownDataReviewPeriodEnd,
  ecomPieChartData, sentimentPieData, intentTypeData, intentPieData, sentimentTotalDetailPieData,
  intentDetailTypeData, intentDetailPieData, intentTypeDataOnlyFour, sentimentTotalPieData
} from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import AgentComment from '../components/AgentComment';
import Dropdown from '../components/Dropdown';
import DataPreview from '../components/DataPreview';
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';

import LineEDAreviewTrend from './Charts/LineEDAreviewTrend';
import LineEDAratingTrend from './Charts/LineEDAratingTrend';
import LineAItotalTrend from './Charts/LineAItotalTrend';
import axios from 'axios';
import Swal from 'sweetalert2';
import AgentCommentMaster from '../components/AgentCommentMaster';

import { useLocation, useNavigate } from "react-router-dom";

const AIresultTotalDetail = () => {
  const [userId, setUserId] = useState('');
  const [unixTime, setUnixTime] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [intentName, setIntentName] = useState(location.state?.intentName || "");
  const currentUrl = window.location.href;

  const { currentColor, currentMode } = useStateContext();
  // 현재 표시할 팔레트
  const [showPalette, setShowPalette] = useState(null);
  const [selectedColors, setSelectedColors] = useState(null);
  const [chartFontSize, setChartFontSize] = useState('12px'); // 글자 크기 상태 관리
  let btnName = "";
  let navLink = "";

  const downloadChartAsImage = async (chartId, fileName) => {
    const chartElement = document.getElementById(chartId); // 캡처할 차트의 DOM 요소
    if (!chartElement) {
      console.error(`Element with ID ${chartId} not found`);
      return;
    }

    try {
      const canvas = await html2canvas(chartElement, { scale: 2 }); // 캔버스로 렌더링
      const link = document.createElement('a');
      link.download = `${fileName}.png`; // 파일 이름
      link.href = canvas.toDataURL('image/png'); // 캡처된 이미지를 PNG로 변환
      link.click(); // 다운로드 실행
    } catch (error) {
      console.error('Error capturing chart:', error);
    }
  };

  let AItype = "";
  let pageTitle = "";
  let AItypeName = "";

  // 감정분류or토픽분류에 따라 데이터셋 다르게 부여
  if (currentUrl.includes('cls/sentiment')) {
    AItype = "classifiedSentiment";
    AItypeName = "감정분류"

  } else if (currentUrl.includes('cls/intent')) {
    AItype = "classifiedIntent";
    AItypeName = "토픽분류"

  } else if (currentUrl.includes('cls/total')) {
    AItype = "classifiedTotal";
    AItypeName = "통합분류"

  } else if (currentUrl.includes('cls/total/result/')) {
    AItype = "classifiedTotalSpecific";
  }

  const [selectedSentimentColors, setSelectedSentimentColors] = useState({
    positive: '#0000FF', // 초기 긍정 색상 (파란색)
    neutral: 'grey', // 초기 중립 색상
    negative: '#FF0000', // 초기 부정 색상 (빨간색)
  });

  const [selectedIntentColors, setSelectedIntentColors] = useState({
    intent1: '#00A86B',      // Jungle Green
    intent2: '#DAA520',      // Goldenrod
    intent3: '#FF8C00',        // Dark Orange
    intent4: '#9932CC', // Dark Orchid
    intent5: '#4682B4',           // Steel Blue
  });

  const [selectedIntentDetailColors, setSelectedIntentDetailColors] = useState([
    {
      intentDetail1: '#66D1AB',
      intentDetail2: '#007A4C',
      intentDetail3: '#009E65'
    },

    {
      intentDetail1: '#FFD566',
      intentDetail2: '#007A4C',
      intentDetail3: '#E6B800'
    },


    {
      intentDetail1: '#FFB84D',
      intentDetail2: '#CC6E00',
      intentDetail3: '#FF7000'
    },


    {
      intentDetail1: '#C278E6',
      intentDetail2: '#731FA3',
      intentDetail3: '#AA00FF'
    },

    {
      intentDetail1: '#4682B4',
    },
  ]);

  const optionsPieSentiment = {
    labels: ['Positive', 'Negative', 'Neutral'],
    // colors: ['#0000FF', '#FF0000', 'grey'], // 원하는 색상 배열
    colors: [selectedSentimentColors.positive,
    selectedSentimentColors.negative,
    selectedSentimentColors.neutral
    ], // 원하는 색상 배열
    legend: {
      show: false,
    },
  };


  // 모달 닫기 핸들러 (키보드 'Esc' 또는 바깥 클릭 시)
  useEffect(() => {

    const storedUserID = localStorage.getItem('userId');
    setUserId(storedUserID || '');
    console.log(`storedUserID: ${storedUserID}`);

    const storedUnixTime = localStorage.getItem('unixTime');
    setUnixTime(storedUnixTime || '');
    console.log(`storedUnixTime: ${storedUnixTime}`);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setShowPalette(null); // Esc 키로 모달 닫기
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown); // 이벤트 클린업
    window.location.reload();
    console.log(`chartFontSize: ${chartFontSize}`);
  }, [location.pathname]);

  // 사용자 색상 변경 핸들러
  const handleColorChange = (args, type) => {
    const chosenColor = args.currentValue.hex;
    if (type in selectedSentimentColors) {
      setSelectedSentimentColors((prevColors) => ({
        ...prevColors,
        [type]: chosenColor,
      }));
    } else if (type in selectedIntentColors) {
      setSelectedIntentColors((prevColors) => ({
        ...prevColors,
        [type]: chosenColor,
      }));
    }
  };

  // 팔레트 컴포넌트
  const CustomColorPicker = ({ id, mode, type }) => (
    <ColorPickerComponent
      id={id}
      mode={mode}
      modeSwitcher={false}
      inline
      showButtons={false}
      change={(args) => handleColorChange(args, type)}
    />
  );

  return (
    <div className="m-2 md:m-5 mt-0 p-2 md:p-5 bg-white rounded-3xl">
      <Button
        color="white"
        bgColor={currentColor}
        text="이전 페이지"
        borderRadius="10px"
        onClick={() => navigate('/cls/total/result')} // 다운로드 핸들러
      />
      <br /><br />
      <Header category={`상세분류결과 조회`} title={`${intentName} 상세분석`} />

      {/* 차트 디자인 편집 그룹 */}
      <div className="bg-white p-8 rounded-3xl shadow-lg">
        <div>
          {intentDetailTypeData[intentName].map((intentDetailName, index) => (
            <div>
              <p className="text-xl font-semibold">{intentDetailName} 리뷰</p><br />
              <div className="flex gap-4 items-stretch">

                <div className="flex-[3] bg-white p-4 rounded-lg">
                  <div className="flex items-center gap-4">
                    <p className="text-xl font-semibold">긍부정 리뷰 구성비(%)</p>
                    <Button
                      color="white"
                      bgColor={currentColor}
                      text="다운로드(.png)"
                      borderRadius="10px"
                      onClick={() => downloadChartAsImage('pie-chart-container',
                        `${intentDetailName}_긍부정 리뷰 구성비율`)} // 다운로드 핸들러
                    />
                  </div>
                  <div id="pie-chart-container">
                    <Pie
                      key={JSON.stringify(selectedSentimentColors)} // 상태 변경 시 리렌더링 강제
                      id={`pie-chart-${index}`}
                      data={sentimentTotalDetailPieData[intentName][intentDetailName]}
                      legendVisiblity={true}
                      colors={[
                        selectedSentimentColors.positive,
                        selectedSentimentColors.negative,
                        selectedSentimentColors.neutral,
                      ]}
                      fontsize={chartFontSize}
                    />
                  </div>
                </div>

                <div className="flex-[7] bg-white p-4 rounded-lg">
                  <div className="flex items-center gap-4">
                    <p className="text-xl font-semibold">긍부정 리뷰 Trend(건)</p>
                    <Button
                      color="white"
                      bgColor={currentColor}
                      text="다운로드(.png)"
                      borderRadius="10px"
                      onClick={() => downloadChartAsImage('line-chart-container',
                        `${intentName}_긍부정 리뷰 Trend 차트`)} // 다운로드 핸들러
                    />
                  </div>
                  <div id="line-chart-container">
                    <LineEDAratingTrend
                      id={`line-chart-${index}`}
                      AItype={AItype}
                      colors={[
                        selectedSentimentColors.negative,
                        selectedSentimentColors.neutral,
                        selectedSentimentColors.positive,
                      ]}
                      fontsize={chartFontSize}
                      intent={intentName}
                    />
                  </div>
                </div>
              </div>
              <hr className="my-8 border-gray-300" />
            </div>

          ))}
        </div>

      </div >
    </div >
  );
};

export default AIresultTotalDetail;
